import styled from '@emotion/styled';

import { createClassNames } from '@hrworks/design-system/functions';

import type { DividerProps } from './Divider.types';

const Divider = styled.hr<Pick<Required<DividerProps>, 'marginBlock'>>(({ theme, marginBlock }) => ({
  border: 'none',
  height: 1,
  width: '100%',
  backgroundColor: theme.eclipseTier2Color.border.bold,
  margin: 0,
  marginBlock: theme.eclipseTier1.spacing[marginBlock],
}));

const components = { Divider };

export const S = {
  ...components,
  ...createClassNames('Divider', components),
} as const;
